<template>
  <v-container fluid>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="countries"
        :footer-props="footerProps"
      >
        <template v-slot:item="{ item }">
         <tr>
          <td>
            <span :class="flagIcon(item.alpha2)">
            </span>
            {{item.name}}
          </td>
          <td>{{item.alpha2}}</td>
          <td>{{item.numeric}}</td>
         </tr> 
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      headers: [{text: 'Name', value: 'name'}, {text: 'Alpha2', value: 'alpha2'}, {text: 'Numeric', value: 'numeric'}, ],
      footerProps: {
        showFirstLastPage: true,
        firstIcon: 'mdi-chevron-double-left',
        lastIcon: 'mdi-chevron-double-right',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right',
        itemsPerPageOptions: [10,20,40]
      },      
    }
  },

  computed: {
    ...mapState({
      countries:  state => state.config.countries
    })
  },

  methods: {
    flagIcon(alpha2) {
      return `flag-icon flag-icon-${alpha2.toLowerCase()}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// Countries.vue?493ad980